import { Component } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import {
  IonicPage,
  NavController,
  NavParams,
  ActionSheetController,
} from "ionic-angular";
import { Camera, CameraOptions } from "@ionic-native/camera";
import { FileTransfer } from "@ionic-native/file-transfer";
import { Observable, ReplaySubject, Subscription, Subject } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { AuthenticationService } from "../../app/core/authentication/authentication.service";
import { NavigationService } from "../../app/services/navigation/navigation.service";
import { UserService } from "../../app/user/user.service";
import { ErrorService } from "../../app/core/error/error.service";
import { takeUntil } from "rxjs/operators";

/**
 * Generated class for the RegistrationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  name: "registration",
})
@Component({
  selector: "page-registration",
  templateUrl: "registration.html",
  providers: [Camera],
})
export class RegistrationPage {
  prevPage: any;
  phoneNumber: "";
  avatar: any;
  password: "";
  privacy: {};
  status = "registered";

  public img: any;
  public isSmsDrawerOpen: boolean;
  public privacyItems: any[];
  public errorServiceConst: Subscription;
  public avatar$: Observable<any>;
  public firstCheck$: Observable<any>;
  public privacyValid: boolean;
  public checkForm: boolean;
  public confirmOpen: boolean = false;
  public userAlreadyRegistrered: boolean;
  private avatarSubject: ReplaySubject<any> = new ReplaySubject(1);
  private unsubscribe: Subject<void> = new Subject<void>();

  registrationForm: any;

  optionsRoll: CameraOptions = {
    destinationType: this.camera.DestinationType.FILE_URI,
    encodingType: this.camera.EncodingType.PNG,
    mediaType: this.camera.MediaType.PICTURE,
    sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
    allowEdit: true,
  };

  optionsPhoto: CameraOptions = {
    destinationType: this.camera.DestinationType.FILE_URI,
    encodingType: this.camera.EncodingType.PNG,
    mediaType: this.camera.MediaType.PICTURE,
    sourceType: this.camera.PictureSourceType.CAMERA,
    allowEdit: true,
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public nav: NavigationService,
    public actionSheetCtrl: ActionSheetController,
    public transfer: FileTransfer,
    private userService: UserService,
    private camera: Camera,
    private auth: AuthenticationService,
    private translate: TranslateService,
    private errorService: ErrorService
  ) {
    this.isSmsDrawerOpen = false;
    this.userAlreadyRegistrered = false;
    this.avatar$ = this.avatarSubject.asObservable();

    // privacy
    // TODO:  i testi si vedono correttamente solo al primo avvio
    // registration
    this.registrationForm = new FormGroup({
      phoneNumber: new FormControl(this.phoneNumber, {
        validators: [
          Validators.required,
          Validators.minLength(7),
          Validators.maxLength(15),
        ],
      }),
      password: new FormControl(this.password, {
        validators: [Validators.required, Validators.minLength(8)],
      }),
    });
  }

  ngOnInit() {
    this.translate
      .get(["PRIVACY_1", "PRIVACY_2", "PRIVACY_3"])
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((res: string) => {
        this.privacyItems = [
          { id: 1, name: res["PRIVACY_1"], value: false },
          { id: 2, name: res["PRIVACY_2"], value: false },
          { id: 3, name: res["PRIVACY_3"], value: false },
        ];
      });
  }

  ionViewDidLoad() {
    if (this.navCtrl.getPrevious() !== null) {
      this.prevPage = this.navCtrl.getPrevious().id;
    }

    if (
      this.userService.getCurrentUser() &&
      this.userService.getCurrentUser().activeRoute === "registered"
    ) {
      this.isSmsDrawerOpen = true;
    }
  }

  onPrivacyCheckbox(event) {
    this.privacyValid = event.length === 3;
  }

  // usernameValue(event){
  //   this.username = event.target.value;
  // }

  phoneValue(event) {
    this.phoneNumber = event.target.value;
  }

  passwordValue(event) {
    this.password = event.target.value;
  }

  goToCreationProfile() {
    if (this.registrationForm.valid) {
      this.auth.registration(
        this.phoneNumber,
        this.password,
        this.privacy,
        this.status
      );
      this.errorServiceConst = this.errorService.isError$
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((msg) => {
          // return msg with USER-ALREADY-EXISTS
          if (msg && msg !== "") {
            this.isSmsDrawerOpen = false;
            this.userAlreadyRegistrered = true;
          }
          if (this.errorServiceConst) this.errorServiceConst.unsubscribe();
        });
      this.isSmsDrawerOpen = true;
      this.userAlreadyRegistrered = false;
    }
    this.registrationForm.controls["phoneNumber"].markAsTouched();
    this.registrationForm.controls["password"].markAsTouched();
  }

  presentActionSheet() {
    const actionSheet = this.actionSheetCtrl.create({
      buttons: [
        {
          text: "Scegli foto",
          role: "Scegli foto",
          handler: () => {
            this.takePhoto(this.optionsRoll);
          },
        },
        {
          text: "Scatta foto",
          role: "Scatta foto",
          handler: () => {
            this.takePhoto(this.optionsPhoto);
          },
        },
        {
          text: "Cancel",
          role: "cancel",
          handler: () => {},
        },
      ],
    });
    actionSheet.present();
  }

  takePhoto(options) {
    this.camera.getPicture(options).then(
      (imageData) => {
        this.img = "data:image/png;base64," + imageData;
        this.avatar = {
          name: imageData.split("/").pop(),
          path: imageData,
        };
        localStorage.setItem("img", this.img);
        this.avatarSubject.next(this.avatar);
      },
      (err) => {
        console.error(err);
      }
    );
  }

  confirmOpenFunction(event) {
    if (event === true) {
      this.isSmsDrawerOpen = false;
      //this.confirmOpen = event;
      this.navCtrl.push("profile-creation");
    } else {
      this.isSmsDrawerOpen = true;
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/pages/registration/registration.ts